module.exports = __webpack_public_path__ + "img/Frame People Desktop.14ecda3d.webp";